// import React, { useEffect, useState } from "react";
// import { Table, Select, Modal, Button, Tag, Card } from "antd";
// import { ApiURL } from "../../../services/apiConstants";
// import { post } from "../../../services/services";
// import { ErrorToast } from "../../../widgets/AppToast";
// import { formatDate } from "../../../utils/dateFormatter";

// const AllIssues = () => {
//   const [page_loader, set_page_loader] = useState(true);

//   const [company_id, set_company_id] = useState("");
//   const [company_list, set_company_list] = useState([]);

//   const [ship_id, set_ship_id] = useState(null);
//   const [ship_list, set_ship_list] = useState([]);

//   const [bugs, setBugs] = useState([]);
//   const [changeRequests, setChangeRequests] = useState([]);
//   const [featureRequests, setFeatureRequests] = useState([]);
//   const [feedbacks, setFeedbacks] = useState([]);

//   const [descrModal, setDescrModal] = useState({
//     visible: false,
//     text: "",
//   });


//   const COMPANY_LIST_API = () => {
//     post(ApiURL.all_company_lising, new FormData()).then((res) => {
//       if (res?.status) {
//         set_company_list(res.data || []);

//         if (res.data?.length > 0) {
//           const first = res.data[0].id;
//           set_company_id(first);
//           ALL_ISSUES_API(first);
//         }
//       }
//     });
//   };


//   const SHIP_LIST_API = (companyId) => {
//     const fd = new FormData();
//     fd.append("company_id", companyId);

//     post(ApiURL.get_ships_by_company, fd).then((res) => {
//       if (res?.status) {
//         set_ship_list(res.ships || []);
//         set_ship_id(null);
//       }
//     });
//   };


//   const ALL_ISSUES_API = (companyId, shipId = null) => {
//     set_page_loader(true);

//     const fd = new FormData();
//     fd.append("company_id", companyId);

//     if (shipId) {
//       fd.append("ship_id", shipId);
//     }

//     post(ApiURL.admin_all_issues, fd)
//       .then((res) => {
//         if (res?.status) {
//           setBugs(res.data?.bugs || []);
//           setChangeRequests(res.data?.change_requests || []);
//           setFeatureRequests(res.data?.feature_requests || []);
//           setFeedbacks(res.data?.feedbacks || []);
//         } else {
//           ErrorToast("Error", res.message);
//         }
//       })
//       .finally(() => set_page_loader(false));
//   };

//   // ========================= First Load ==========================
//   useEffect(() => {
//     COMPANY_LIST_API();
//   }, []);

//   // ===================== When company changes ====================
//   useEffect(() => {
//     if (company_id) {
//       SHIP_LIST_API(company_id);
//       ALL_ISSUES_API(company_id);
//     }
//   }, [company_id]);

//   // ===================== When ship changes =======================
//   useEffect(() => {
//     if (!company_id) return;

//     if (ship_id) {
//       ALL_ISSUES_API(company_id, ship_id);
//     } else {
//       ALL_ISSUES_API(company_id);
//     }
//   }, [ship_id]);


//   const showDescription = (record) => {
//     setDescrModal({ visible: true, text: record.description });
//   };

//   const renderSeverity = (severity) => {
//     const map = {
//       high: "red",
//       medium: "orange",
//       low: "green",
//       important: "blue",
//       nice_to_have: "purple",
//     };
//     return <Tag color={map[severity] || "default"}>{severity}</Tag>;
//   };


//   const getColumns = (idKey, severityKey = null) =>
//     [
//       {
//         title: "ID",
//         align: "center",
//         render: (row) => row[idKey],
//       },
//       {
//         title: "Title",
//         dataIndex: "title",
//         align: "center",
//       },
//       {
//         title: "Description",
//         align: "center",
//         render: (row) => (
//           <Button type="link" onClick={() => showDescription(row)}>
//             View
//           </Button>
//         ),
//       },
//       severityKey
//         ? {
//             title: "Status",
//             align: "center",
//             render: (row) => renderSeverity(row[severityKey]),
//           }
//         : null,
//       {
//         title: "Created At",
//         dataIndex: "created_at",
//         align: "center",
//         render: (txt) => formatDate(txt),
//       },
//       {
//         title: "Ship",
//         dataIndex: "ship_name",
//         align: "center",
//       },
//     ].filter(Boolean);

//   return (
//     <div style={{ padding: "15px" }}>
//       {/* FILTER BAR */}
//       <Card style={{ marginBottom: "20px" }}>
//         <div style={{ display: "flex", gap: "15px" }}>
//           {/* COMPANY SELECT */}
//           <div style={{ flex: 1 }}>
//             <label>
//               <b>Select Company</b>
//             </label>
//             <Select
//               style={{ width: "100%", marginTop: "6px" }}
//               value={company_id}
//               onChange={(val) => set_company_id(val)}
//             >
//               {company_list.map((c) => (
//                 <Select.Option key={c.id} value={c.id}>
//                   {c.company_name}
//                 </Select.Option>
//               ))}
//             </Select>
//           </div>

//           {/* SHIP SELECT */}
//           <div style={{ flex: 1 }}>
//             <label>
//               <b>Select Ship (Optional)</b>
//             </label>
//             <Select
//               allowClear
//               placeholder="All Ships"
//               style={{ width: "100%", marginTop: "6px" }}
//               value={ship_id}
//               onChange={(val) => set_ship_id(val)}
//             >
//               {ship_list.map(
//                 (s) =>
//                   !s.soft_delete && (
//                     <Select.Option key={s.id} value={s.id}>
//                       {s.vessel_name}
//                     </Select.Option>
//                   )
//               )}
//             </Select>
//           </div>
//         </div>
//       </Card>

//       {/* BUGS */}
//       <Card title={`🐞 Bugs (${bugs.length})`} bordered>
//         <Table
//           bordered
//           columns={getColumns("bug_id", "severity")}
//           dataSource={bugs}
//           loading={page_loader}
//           pagination={{ pageSize: 5 }}
//           rowKey="id"
//         />
//       </Card>

//       {/* CHANGE REQUESTS */}
//       <Card
//         title={`🔧 Change Requests (${changeRequests.length})`}
//         bordered
//         style={{ marginTop: "20px" }}
//       >
//         <Table
//           bordered
//           columns={getColumns("request_id")}
//           dataSource={changeRequests}
//           loading={page_loader}
//           pagination={{ pageSize: 5 }}
//           rowKey="id"
//         />
//       </Card>

//       {/* FEATURE REQUESTS */}
//       <Card
//         title={`✨ Feature Requests (${featureRequests.length})`}
//         bordered
//         style={{ marginTop: "20px" }}
//       >
//         <Table
//           bordered
//           columns={getColumns("feature_id", "priority")}
//           dataSource={featureRequests}
//           loading={page_loader}
//           pagination={{ pageSize: 5 }}
//           rowKey="id"
//         />
//       </Card>

//       {/* FEEDBACK */}
//       <Card
//         title={`💡 Feedback (${feedbacks.length})`}
//         bordered
//         style={{ marginTop: "20px" }}
//       >
//         <Table
//           bordered
//           columns={getColumns("feedback_id")}
//           dataSource={feedbacks}
//           loading={page_loader}
//           pagination={{ pageSize: 5 }}
//           rowKey="id"
//         />
//       </Card>

//       {/* DESCRIPTION MODAL */}
//       <Modal
//         title="Description"
//         open={descrModal.visible}
//         footer={null}
//         onCancel={() => setDescrModal({ visible: false, text: "" })}
//       >
//         <p>{descrModal.text}</p>
//       </Modal>
//     </div>
//   );
// };

// export default AllIssues;


import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button, Tag, Card } from "antd";
import { ApiURL } from "../../../services/apiConstants";
import { post } from "../../../services/services";
import { ErrorToast } from "../../../widgets/AppToast";
import { formatDate } from "../../../utils/dateFormatter";

const BASE_URL = process.env.REACT_APP_API_URL;

const AllIssues = () => {
  const [page_loader, set_page_loader] = useState(true);

  const [company_id, set_company_id] = useState(null);
  const [company_list, set_company_list] = useState([]);

  const [ship_id, set_ship_id] = useState(null);
  const [ship_list, set_ship_list] = useState([]);

  const [bugs, setBugs] = useState([]);
  const [changeRequests, setChangeRequests] = useState([]);
  const [featureRequests, setFeatureRequests] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);

  /* ---------------- DESCRIPTION MODAL ---------------- */
  const [descrModal, setDescrModal] = useState({
    visible: false,
    text: "",
  });

  /* ---------------- ATTACHMENT MODAL ---------------- */
  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    url: "",
  });

  /* ================= COMPANY LIST ================= */
  const COMPANY_LIST_API = () => {
    post(ApiURL.all_company_lising, new FormData()).then((res) => {
      if (res?.status) {
        set_company_list(res.data || []);
        ALL_ISSUES_API();
      }
    });
  };

  /* ================= SHIP LIST ================= */
  const SHIP_LIST_API = (companyId) => {
    const fd = new FormData();
    fd.append("company_id", companyId);

    post(ApiURL.get_ships_by_company, fd).then((res) => {
      if (res?.status) {
        set_ship_list(res.ships || []);
        set_ship_id(null);
      }
    });
  };

  /* ================= ALL ISSUES ================= */
  const ALL_ISSUES_API = (companyId = null, shipId = null) => {
    set_page_loader(true);

    const fd = new FormData();
    if (companyId) fd.append("company_id", companyId);
    if (shipId) fd.append("ship_id", shipId);

    post(ApiURL.admin_all_issues, fd)
      .then((res) => {
        if (res?.status) {
          setBugs(res.data?.bugs || []);
          setChangeRequests(res.data?.change_requests || []);
          setFeatureRequests(res.data?.feature_requests || []);
          setFeedbacks(res.data?.feedbacks || []);
        } else {
          ErrorToast("Error", res.message);
        }
      })
      .finally(() => set_page_loader(false));
  };

  /* ================= LIFECYCLE ================= */
  useEffect(() => {
    COMPANY_LIST_API();
  }, []);

  useEffect(() => {
    if (!company_id) {
      set_ship_list([]);
      set_ship_id(null);
      ALL_ISSUES_API();
      return;
    }

    SHIP_LIST_API(company_id);
    ALL_ISSUES_API(company_id);
  }, [company_id]);

  useEffect(() => {
    if (!company_id) return;

    ship_id
      ? ALL_ISSUES_API(company_id, ship_id)
      : ALL_ISSUES_API(company_id);
  }, [ship_id]);

  /* ================= HELPERS ================= */
  const showDescription = (record) => {
    setDescrModal({ visible: true, text: record.description });
  };

  const showAttachment = (path) => {
    setAttachmentModal({
      visible: true,
      // url: `${BASE_URL}${path}`,
      url: path,
    });
  };

  const renderSeverity = (severity) => {
    const map = {
      high: "red",
      medium: "orange",
      low: "green",
      important: "blue",
      nice_to_have: "purple",
      urgent: "volcano",
      critical: "magenta",
    };
    return <Tag color={map[severity] || "default"}>{severity}</Tag>;
  };

  /* ================= COLUMN FACTORY ================= */
  const getColumns = (idKey, severityKey = null) =>
    [
      {
        title: "ID",
        align: "center",
        render: (row) => row[idKey],
      },
      {
        title: "Title",
        dataIndex: "title",
        align: "center",
      },
      {
        title: "Description",
        align: "center",
        render: (row) => (
          <Button type="link" onClick={() => showDescription(row)}>
            View
          </Button>
        ),
      },
      {
        title: "Attachment",
        align: "center",
        render: (row) =>
          row?.attachment ? (
            <Button
              type="link"
              onClick={() => showAttachment(row.attachment)}
            >
              View
            </Button>
          ) : (
            "—"
          ),
      },
      severityKey
        ? {
            title: "Status",
            align: "center",
            render: (row) => renderSeverity(row[severityKey]),
          }
        : null,
      {
        title: "Created At",
        dataIndex: "created_at",
        align: "center",
        render: (txt) => formatDate(txt),
      },
      {
        title: "Ship",
        dataIndex: "ship_name",
        align: "center",
      },
    ].filter(Boolean);

  return (
    <div style={{ padding: "15px" }}>
      {/* ---------------- FILTER BAR ---------------- */}
      <Card style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex", gap: "15px" }}>
          <div style={{ flex: 1 }}>
            <label><b>Select Company</b></label>
            <Select
              allowClear
              placeholder="All Companies"
              style={{ width: "100%", marginTop: "6px" }}
              value={company_id}
              onChange={set_company_id}
            >
              {company_list.map((c) => (
                <Select.Option key={c.id} value={c.id}>
                  {c.company_name}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div style={{ flex: 1 }}>
            <label><b>Select Ship (Optional)</b></label>
            <Select
              allowClear
              placeholder="All Ships"
              style={{ width: "100%", marginTop: "6px" }}
              value={ship_id}
              onChange={set_ship_id}
              disabled={!company_id}
            >
              {ship_list.map(
                (s) =>
                  !s.soft_delete && (
                    <Select.Option key={s.id} value={s.id}>
                      {s.vessel_name}
                    </Select.Option>
                  )
              )}
            </Select>
          </div>
        </div>
      </Card>

      {/* ---------------- TABLES ---------------- */}
      <Card title={`🐞 Bugs (${bugs.length})`}>
        <Table bordered columns={getColumns("bug_id", "severity")} dataSource={bugs} loading={page_loader} pagination={{ pageSize: 5 }} rowKey="id" />
      </Card>

      <Card title={`🔧 Change Requests (${changeRequests.length})`} style={{ marginTop: 20 }}>
        <Table bordered columns={getColumns("request_id")} dataSource={changeRequests} loading={page_loader} pagination={{ pageSize: 5 }} rowKey="id" />
      </Card>

      <Card title={`✨ Feature Requests (${featureRequests.length})`} style={{ marginTop: 20 }}>
        <Table bordered columns={getColumns("feature_id", "priority")} dataSource={featureRequests} loading={page_loader} pagination={{ pageSize: 5 }} rowKey="id" />
      </Card>

      <Card title={`💡 Feedback (${feedbacks.length})`} style={{ marginTop: 20 }}>
        <Table bordered columns={getColumns("feedback_id")} dataSource={feedbacks} loading={page_loader} pagination={{ pageSize: 5 }} rowKey="id" />
      </Card>

      {/* ---------------- DESCRIPTION MODAL ---------------- */}
      <Modal
        title="Description"
        open={descrModal.visible}
        footer={null}
        onCancel={() => setDescrModal({ visible: false, text: "" })}
      >
        <p>{descrModal.text}</p>
      </Modal>

      {/* ---------------- ATTACHMENT MODAL ---------------- */}
      <Modal
        title="Attachment Preview"
        open={attachmentModal.visible}
        footer={null}
        width={700}
        onCancel={() =>
          setAttachmentModal({ visible: false, url: "" })
        }
      >
        <img
          src={attachmentModal.url}
          alt="Attachment"
          style={{ width: "100%", borderRadius: "6px" }}
        />
      </Modal>
    </div>
  );
};

export default AllIssues;
